<!--首页-->
<template>
    <v-main width="100%" height="100%" id="mian">
        <top-bar
            isHome
            @open="open"
            v-if="navigationMode == 'vertical'"
            :height="'60vh'"
            :faultNums="faultData.length"
        />
        <v-container fluid class="mt-n7 nav">
            <div class="handler">
                <div class="handler-card center" v-for="(item, index) in label" :key="index">
                    <div class="nav-card">
                        <el-card
                            shadow="hover"
                            :style="{
                                height: '100%',
                                backgroundColor: theme.elementBgColor,
                                border: 'none',
                            }"
                        >
                            <v-row>
                                <v-col
                                    cols="4"
                                    md="4"
                                    align="center"
                                    justify="center"
                                >
                                    <i
                                        :class="item.icon"
                                        :style="{
                                            fontSize: '2.2em',
                                            color: item.iconColor,
                                        }"
                                    ></i>
                                </v-col>
                                <v-col cols="8" md="8" align="center" justify="center">
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            md="12"
                                            :style="{
                                                fontSize: '1.5vw',
                                                color: theme.pageFontColor,
                                            }"
                                        >
                                            {{ item.nums }}
                                            <span
                                                style="font-size: 0.8rem;font-weight:200"
                                                v-if="index == 0 || index == 2"
                                            >
                                                (￥)
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="12"
                                            class="mt-n6"
                                            :style="{
                                                fontSize: '1vw',
                                                color: theme.pageFontColor,
                                            }"
                                        >
                                            {{ item.title }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </el-card>
                    </div>
                </div>
            </div>
            <div class="money-echarts center" :style="{ backgroundColor: theme.elementBgColor }">
                <div class="money-btn">
                    <v-btn class="btn" text icon :loading="moneyLoading" @click="moneyRefresh()">
                        <v-icon>mdi-cached</v-icon>
                    </v-btn>
                    <el-date-picker
                        class="date-picker"
                        v-model="monthTime"
                        type="monthrange"
                        range-separator="至"
                        start-placeholder="开始月份"
                        end-placeholder="结束月份"
                        value-format="timestamp"
                        @change="monthChange"
                    ></el-date-picker>
                </div>
                <money-echarts />
            </div>
            <div class="rank-accounted-echarts">
                <div class="rank-echarts center" :style="{ backgroundColor: theme.elementBgColor }">
                    <div class="rank-btn">
                        <v-btn text icon :loading="rankLoading" @click="rankRefresh()">
                            {{ rankText }}
                            <v-icon>mdi-cached</v-icon>
                        </v-btn>
                    </div>
                    <site-rank-echarts />
                </div>
                <!-- <div class="box"></div> -->
                <div class="accounted-echarts">
                    <div class="accounted-power" :style="{ backgroundColor: theme.elementBgColor }">
                        <accounted-money />
                    </div>
                    <!-- <div class="box2"></div> -->
                    <div
                        class="accounted-monney"
                        :style="{ backgroundColor: theme.elementBgColor }"
                    >
                        <accounted-power />
                    </div>
                </div>
            </div>
        </v-container>
        <el-dialog title="故障设备信息" :visible.sync="openFaultTable" width="60%">
            <fault-equipment :faultData="faultData" />
        </el-dialog>
    </v-main>
</template>

<script>
import SiteRankEcharts from "@/components/Echarts/SiteRankEcharts";
import MoneyEcharts from "@/components/Echarts/MoneyEcharts";
import AccountedPower from "@/components/Echarts/AccountedPower";
import AccountedMoney from "@/components/Echarts/AccountedMoney";
import FaultEquipment from "@/components/Table/FaultEquipment";
import TopBar from "@/components/TopBar";
import { mapState } from "vuex";
import store from "@/store";
import Public from "@/public";
export default {
    name: "Home",
    data() {
        return {
            monthTime: [],
            openFaultTable: false,
            label: [
                {
                    icon: "iconfont icon-jine",
                    iconColor: "#FFCF7A",
                    title: "上周金额总计",
                    nums: 0,
                },
                {
                    icon: "iconfont icon-dianliang",
                    iconColor: "#DA3B27",
                    title: "上周电量总计",
                    nums: 0,
                },
                {
                    icon: "iconfont icon-jine1",
                    iconColor: "#EF7358",
                    title: "今日金额总计",
                    nums: 0,
                },
                {
                    icon: "iconfont icon-dianliang",
                    iconColor: "#DA3B27",
                    title: "今日电量总计",
                    nums: 0,
                },
            ],
            rankLoading: false,
            moneyLoading: false,
            rankText: "昨天",
        };
    },
    computed: {
        ...mapState(["theme", "navigationMode", "faultData", "dayOrderSummary"]),
    },
    components: {
        SiteRankEcharts, //站点排行
        MoneyEcharts, //金额表
        TopBar,
        FaultEquipment,
        AccountedPower,
        AccountedMoney,
    },
    created() {
        this.moneyRefresh();
        this.rankRefresh();
    },
    mounted() {},
    methods: {
        monthChange(event) {
            if (!event) {
                return;
            }
            let end_time =
                new Date(event[1]).getTime() +
                this.getDays(new Date(event[1])) * 3600 * 24 * 1000 -
                1;
            let start_time = new Date(event[0]).getTime();
            this.getMonthOrderSummary(start_time, end_time);
        },
        async moneyRefresh() {
            this.moneyLoading = true;
            let start_time;
            let end_time;
            if (this.monthTime == null || this.monthTime.length == 0) {
                let t1 = new Date(new Date().toLocaleDateString()).getTime();
                end_time = t1 + 3600 * 1000 * 24;
                start_time = t1 - 3600 * 1000 * 24 * 365;
                this.monthTime = [start_time, end_time];
            } else if (this.monthTime.length != 0) {
                end_time =
                    new Date(this.monthTime[1]).getTime() +
                    this.getDays(new Date(this.monthTime[1])) * 3600 * 24 * 1000 -
                    1000;
                start_time = new Date(this.monthTime[0]).getTime();
            }
            if (end_time == start_time) {
                end_time = end_time + this.getDays(new Date(end_time)) * 3600 * 24 * 1000 - 1000;
            } else if (end_time > new Date().getTime()) {
                end_time = new Date().getTime();
            }
            await this.getMonthOrderSummary(start_time, end_time);

            let start_time2 = new Date(this.getTime(7)).getTime() - 8 * 3600 * 1000;
            let end_time2 = new Date(this.getTime(1)).getTime() + 16 * 3600 * 1000;
            await this.getDayOrderSummary(start_time2, end_time2);
        },
        rankRefresh() {
            let start_time;
            let end_time;
            this.rankLoading = true;
            if (this.rankText == "上周") {
                start_time = new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24;
                end_time = new Date(new Date().toLocaleDateString()).getTime() - 1;
                this.rankText = "昨天";
            } else if (this.rankText == "昨天") {
                start_time = new Date(this.getTime(7)).getTime() - 8 * 3600 * 1000;
                end_time = new Date(this.getTime(1)).getTime() + 16 * 3600 * 1000;
                this.rankText = "上周";
            }
            this.getSiteOrderSummary(start_time, end_time);
        },
        /*获取 天 的金额电量相关数据报表数据*/
        async getDayOrderSummary(start_time, end_time) {
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 0,
                },
                callback: () => {
                    // this.rankLoading = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
            let lastWeekMoney = 0;
            let lastWeekPower = 0;
            if (this.dayOrderSummary.length > 1) {
                for (let i = 0; i < this.dayOrderSummary.length; i++) {
                    lastWeekMoney = this.addNum(lastWeekMoney, this.dayOrderSummary[i].money);
                    lastWeekPower = this.addNum(lastWeekPower, this.dayOrderSummary[i].power);
                }
                this.label[0].nums = lastWeekMoney.toFixed(2);
                this.label[1].nums = lastWeekPower.toFixed(2);

                let now_day_end_time = new Date().getTime();
                let now_day_start_time = new Date(new Date().toLocaleDateString()).getTime();
                this.getDayOrderSummary(now_day_start_time, now_day_end_time);
            } else {
                for (let i = 0; i < this.dayOrderSummary.length; i++) {
                    this.label[2].nums = this.dayOrderSummary[i].money;
                    this.label[3].nums = this.dayOrderSummary[i].power;
                }
                this.label[2].nums = this.label[2].nums.toFixed(2);
                this.label[3].nums = this.label[3].nums.toFixed(2);
            }
        },
        /*获取 月 的金额电量相关数据报表数据*/
        async getMonthOrderSummary(start_time, end_time) {
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 1,
                },
                callback: () => {
                    this.moneyLoading = false;
                },
            };

            await store.dispatch("getOrderSummary", params);
        },
        /*获取 站点 的金额电量相关数据报表数据*/
        async getSiteOrderSummary(start_time, end_time) {
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 2,
                },
                callback: () => {
                    this.rankLoading = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
        },
        open() {
            this.openFaultTable = true;
        },
        /**
            n = 7 上周开始时间
            n = 1 上周结束时间
            n = 0 本周开始时间
            n = -6 本周结束时间
            n = -7 下周开始时间
            n = -13 下周结束时间
         */
        getTime(n) {
            var now = new Date();
            var year = now.getFullYear();
            //因为月份是从0开始的,所以获取这个月的月份数要加1才行
            var month = now.getMonth() + 1;
            var date = now.getDate();
            var day = now.getDay();
            //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
            if (day !== 0) {
                n = n + (day - 1);
            } else {
                n = n + day;
            }
            if (day) {
                //这个判断是为了解决跨年的问题
                if (month > 1) {
                    month = month;
                }
                //这个判断是为了解决跨年的问题,月份是从0开始的
                else {
                    year = year - 1;
                    month = 12;
                }
            }
            now.setDate(now.getDate() - n);
            year = now.getFullYear();
            month = now.getMonth() + 1;
            date = now.getDate();
            var s =
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date);
            return s;
        },
        /*相加*/
        addNum(num1, num2) {
            var r1, r2, m;
            try {
                r1 = num1.toString().split(".")[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = num2.toString().split(".")[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            let num = Math.round(num1 * m + num2 * m) / m;
            return num;
        },
        getDays(date) {
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var d = new Date(year, month, 0);
            return d.getDate();
        },
    },
};
</script>

<style scoped>
@import "../assets/css/home.css";
.nav {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.money-echarts {
    width: 100%;
    height: 36rem;
    margin-top: 1rem;
    border-radius: 2rem;
}
</style>
